// extracted by mini-css-extract-plugin
export var container = "_6c-0";
export var error = "_6c-9";
export var label = "_6c-5";
export var light = "_6c-6";
export var md = "_6c-3";
export var sm = "_6c-2";
export var thin = "_6c-8";
export var thinBold = "_6c-7";
export var vertical = "_6c-4";
export var xs = "_6c-1";